// Fix Menu

(function($) {
  
  $('.navbar-toggle').on('click', function(){
    $('.launcher-button').hide(); 
});
  
  $('.header_messages .grid').slick({
    autoplay: true,
  dots: false,
    arrows: false,
  infinite: true,
  speed: 300,
    mobileFirst: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: "unslick"
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
  speed: 300,
    mobileFirst: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
}); 
  
})(jQuery);

(function() {
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var brokenMoneyRegex = /\{\{\s*amount[^}]*\}\}/i;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? (decimal + parts[1]) : '';
    return dollarsAmount + centsAmount;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var formatString = format || (window.theme && theme.moneyFormat) || '${{amount}}';
    var match = formatString.match(placeholderRegex);
    if (!match) {
      return formatString;
    }
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  window.slate = window.slate || {};
  slate.Currency = slate.Currency || {};
  slate.Currency.formatMoney = formatMoney;

  function centsFromPriceValue(raw) {
    if (raw == null || raw === '') {
      return null;
    }
    var text = String(raw).trim().replace(/[^\d.,-]/g, '').replace(',', '.');
    var number = parseFloat(text);
    if (isNaN(number)) {
      return null;
    }
    if (String(raw).indexOf('.') !== -1 || String(raw).indexOf(',') !== -1) {
      return Math.round(number * 100);
    }
    return Math.round(number);
  }

  function findCents(el) {
    var node = el;
    while (node && node.nodeType === 1) {
      var cents = centsFromPriceValue(
        node.getAttribute('orig-price') ||
        node.getAttribute('data-price') ||
        node.getAttribute('data-variant-price')
      );
      if (cents != null) {
        return cents;
      }
      node = node.parentNode;
    }
    return null;
  }

  function repairElement(el) {
    if (!el || el.nodeType !== 1 || !brokenMoneyRegex.test(el.innerHTML || '')) {
      return;
    }
    var cents = findCents(el);
    if (cents == null) {
      return;
    }
    var formatted = formatMoney(cents, window.theme && theme.moneyFormat);
    if (el.children.length === 0) {
      el.textContent = formatted;
      return;
    }
    el.innerHTML = el.innerHTML.replace(/[€$£]?\s*\{\{\s*amount[^}]*\}\}(?:\s*[A-Z]{3})?/ig, formatted);
  }

  function repairBrokenMoney(root) {
    var scope = root && root.nodeType === 1 ? root : document.body;
    if (!scope) {
      return;
    }
    repairElement(scope);
    var nodes = scope.querySelectorAll('[orig-price], [data-product-price], [data-compare-price], .value-price, .radio__item--price, .mw-product-options *');
    for (var i = 0; i < nodes.length; i++) {
      repairElement(nodes[i]);
    }
  }

  function closeCountryPicker(root) {
    if (!root) {
      return;
    }
    var toggle = root.querySelector('.country-picker__toggle');
    var panel = root.querySelector('.country-picker__panel');
    var search = root.querySelector('.country-picker__search');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
    if (panel) {
      panel.hidden = true;
    }
    if (search) {
      search.value = '';
      filterCountryPicker(root, '');
    }
  }

  function openCountryPicker(root) {
    var pickers = document.querySelectorAll('.country-picker');
    for (var i = 0; i < pickers.length; i++) {
      if (pickers[i] !== root) {
        closeCountryPicker(pickers[i]);
      }
    }
    var toggle = root.querySelector('.country-picker__toggle');
    var panel = root.querySelector('.country-picker__panel');
    var search = root.querySelector('.country-picker__search');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    }
    if (panel) {
      panel.hidden = false;
    }
    if (search) {
      search.focus();
    }
  }

  function filterCountryPicker(root, query) {
    var term = (query || '').toLowerCase().trim();
    var options = root.querySelectorAll('.country-picker__option');
    var hint = root.querySelector('[data-country-hint]');
    var empty = root.querySelector('.country-picker__empty');
    var visible = 0;
    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      var haystack = (option.getAttribute('data-search') || option.textContent || '').toLowerCase();
      var isPopular = option.getAttribute('data-popular') === 'true';
      var isSelected = option.classList.contains('is-selected');
      var show = term ? haystack.indexOf(term) !== -1 : (isPopular || isSelected);
      option.parentNode.hidden = !show;
      if (show) {
        visible += 1;
      }
    }
    if (hint) {
      hint.textContent = term
        ? (hint.getAttribute('data-search-label') || 'Matching countries')
        : (hint.getAttribute('data-popular-label') || 'Popular countries');
      hint.hidden = visible === 0;
    }
    if (empty) {
      empty.hidden = visible > 0;
    }
  }

  function bindCountryPicker() {
    document.addEventListener('change', function(event) {
      var select = event.target;
      if (!select || select.name !== 'country_code' || select.type === 'hidden') {
        return;
      }
      if (select.form) {
        select.form.submit();
      }
    });

    document.addEventListener('click', function(event) {
      var toggle = event.target.closest && event.target.closest('.country-picker__toggle');
      var option = event.target.closest && event.target.closest('.country-picker__option');
      var picker = event.target.closest && event.target.closest('.country-picker');

      if (toggle) {
        event.preventDefault();
        var root = toggle.closest('.country-picker');
        if (toggle.getAttribute('aria-expanded') === 'true') {
          closeCountryPicker(root);
        } else {
          openCountryPicker(root);
        }
        return;
      }

      if (option) {
        event.preventDefault();
        var form = option.closest('.country-picker');
        var input = form && form.querySelector('input[name="country_code"]');
        var code = option.getAttribute('data-country');
        if (input && code) {
          input.value = code;
          form.submit();
        }
        return;
      }

      if (!picker) {
        var openPickers = document.querySelectorAll('.country-picker .country-picker__toggle[aria-expanded="true"]');
        for (var i = 0; i < openPickers.length; i++) {
          closeCountryPicker(openPickers[i].closest('.country-picker'));
        }
      }
    });

    document.addEventListener('input', function(event) {
      if (!event.target.classList || !event.target.classList.contains('country-picker__search')) {
        return;
      }
      filterCountryPicker(event.target.closest('.country-picker'), event.target.value);
    });

    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Escape') {
        return;
      }
      var openToggle = document.querySelector('.country-picker__toggle[aria-expanded="true"]');
      if (openToggle) {
        var root = openToggle.closest('.country-picker');
        closeCountryPicker(root);
        openToggle.focus();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' || !event.target.classList || !event.target.classList.contains('country-picker__search')) {
        return;
      }
      event.preventDefault();
      var root = event.target.closest('.country-picker');
      var visible = root.querySelectorAll('.country-picker__list li:not([hidden]) .country-picker__option');
      if (visible.length) {
        visible[0].click();
      }
    });
  }

  function startObserver() {
    if (!document.body || typeof MutationObserver === 'undefined') {
      return;
    }
    var timer;
    var observer = new MutationObserver(function() {
      clearTimeout(timer);
      timer = setTimeout(function() {
        repairBrokenMoney(document.body);
      }, 50);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['orig-price', 'data-price']
    });
  }

  document.addEventListener('mouseenter', function (event) {
    var link = event.target.closest && event.target.closest('.grid-view-item__link');
    if (!link) return;
    var img = link.querySelector('img.second-image[data-hover-src]');
    if (!img) return;
    var hoverSrc = img.getAttribute('data-hover-src');
    if (!hoverSrc) return;
    function markReady() {
      img.classList.add('is-ready');
    }
    if (img.getAttribute('src') !== hoverSrc) {
      img.addEventListener('load', markReady, { once: true });
      img.src = hoverSrc;
    } else if (img.complete) {
      markReady();
    }
  }, true);

  bindCountryPicker();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      repairBrokenMoney(document.body);
      startObserver();
    });
  } else {
    repairBrokenMoney(document.body);
    startObserver();
  }
})();
